import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=535230d2&scoped=true"
import script from "./MyWallet.vue?vue&type=script&lang=js"
export * from "./MyWallet.vue?vue&type=script&lang=js"
import style0 from "./MyWallet.vue?vue&type=style&index=0&id=535230d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535230d2",
  null
  
)

export default component.exports